import { render, staticRenderFns } from "./LgFinderPageLocalArmazenamentoModal.vue?vue&type=template&id=1182e915"
import script from "./LgFinderPageLocalArmazenamentoModal.vue?vue&type=script&lang=js"
export * from "./LgFinderPageLocalArmazenamentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports